import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  authUser: null
};



export function sessionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.AUTH_USER_SET: {
      return {
        ...state,
        authUser: action.authUser
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.reducer.js